//系统参数配置
//export const API_URL ='http://api.cmopd.cn'
// export const API_URL ='http://192.168.91.95/'
export const API_URL ='http://rap2api.taobao.org/app/mock/'
// export const SMS_URL ='http://api.cmopd.cn/'
// export const AUTH_URL ='http://api.cmopd.cn/auth/'
// export const WXLOGIN_URL ='http://api.cmopd.cn/wx/auth/login'
// export const UP_URL ='http://api.cmopd.cn/admin/attach/'
// export const SHARE_URL ='http://point.wx.cmopd.cn/?#/share/'

//登录配置
export const SET_HISARR = 'SET_HISARR'
export const SET_CITY = 'SET_CITY'
export const SET_TOKEN = 'SET_TOKEN'


// export const SET_BID = 'SET_BID'
// export const SET_SIZE = 'SET_SIZE'
// export const SET_AREAID = 'SET_AREAID'
// export const SET_AREANAME = 'SET_AREANAME'
// export const SET_USERCHECK = 'SET_USERCHECK'
// export const SET_LIST = 'SET_LIST'
// //登出
// export const CLEAN_ALL = 'CLEAN_ALL'
//
// export const SET_BACKURL = 'SET_BACKURL'

//底部菜单
export  const HIDE_FOOTER = "HIDE_FOOTER"
export  const KEEP_ALIVE  = "KEEP_ALIVE"
export  const TABNAME  = "TABNAME"

// //** 商品列表
// export  const SET_SCOLL  = "SET_SCOLL"
// export  const SET_GOODS  = "SET_GOODS"
// //首页导航
// export const SAVE_POSITION = 'SAVE_POSITION'



// WEBPACK FOOTER //
// ./src/store/constant.js


// WEBPACK FOOTER //
// ./src/store/constant.js